import { render, staticRenderFns } from "./grade.vue?vue&type=template&id=35a1967a&"
import script from "./grade.vue?vue&type=script&lang=js&"
export * from "./grade.vue?vue&type=script&lang=js&"
import style0 from "./grade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports